import React from 'react';
import './Footer.css';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="container footer-content">
        <div className="footer-section">
          <h4>ONLINE SHOPPING</h4>
          <ul>
            <li>Men</li>
            <li>Women</li>
            <li>Kids</li>
            <li>Home & Living</li>
            <li>Beauty</li>
            <li>Gift Cards</li>
          </ul>
        </div>
        <div className="footer-section">
          <h4>CUSTOMER POLICIES</h4>
          <ul>
            <li>Contact Us</li>
            <li>FAQ</li>
            <li>T&C</li>
            <li>Terms Of Use</li>
            <li>Track Orders</li>
            <li>Shipping</li>
            <li>Cancellation</li>
            <li>Returns</li>
          </ul>
        </div>
        <div className="footer-section">
          <h4>EXPERIENCE APP ON MOBILE</h4>
          <div className="app-download">
             <div className="app-badge">Google Play</div>
             <div className="app-badge">App Store</div>
          </div>
          <h4 className="keep-in-touch">KEEP IN TOUCH</h4>
          <div className="social-links">
            <span>fb</span> <span>tw</span> <span>yt</span> <span>in</span>
          </div>
        </div>
        <div className="footer-section">
          <div className="promise">
            <div className="promise-item">
              <strong>100% ORIGINAL</strong> guarantee for all products
            </div>
            <div className="promise-item">
              <strong>Return within 14days</strong> of receiving your order
            </div>
          </div>
        </div>
      </div>
      <div className="footer-bottom">
        <div className="container">
          <p>© 2026 www.below2000.com. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
